import React, { useState } from "react";
import ReactDatatable from "@mkikets/react-datatable";
import { useGetStakingPlanQuery } from "../../../redux/stakingPlanApi";
import { useGetCryptocurrencyQuery } from "../../../redux/cryptocurrencyApi";
import { Button } from "react-bootstrap";
import AddStakingPlan from "../../partial/AddStakingPlan";
import EditStakingPlan from "../../partial/EditStakingPlan";
import ViewStakingPlan from "../../partial/ViewStakingPlan";

import { useTranslation } from "react-i18next";

function StakingPlans() {
    const { t } = useTranslation();
    const { data: apiResponse } = useGetStakingPlanQuery();
    const { data: cryptoResponse } = useGetCryptocurrencyQuery();

    const plans = apiResponse?.data || [];
    const cryptocurrencies = cryptoResponse?.data || [];

    // Edit Modal State
    const [showEdit, setShowEdit] = useState(false);
    const [editData, setEditData] = useState({});

    const handleEdit = (plan) => {
        setEditData(plan);
        setShowEdit(true);
    };

    // View Modal State
    const [showView, setShowView] = useState(false);
    const [viewData, setViewData] = useState({});

    const handleView = (plan) => {
        setViewData(plan);
        setShowView(true);
    };

    // Add Modal State
    const [showAdd, setShowAdd] = useState(false);

    const columns = [
        {
            key: "srno.",
            text: t('sr_no'),
            className: "sr_no.",
            align: "left",
            sortable: true,
            cell: (row, index) => index + 1,
        },
        {
            key: "cryptocurrency_id",
            text: t('cryptocurrency'),
            className: "cryptocurrency",
            align: "left",
            sortable: true,
            cell: (record) => {
                const crypto = cryptocurrencies.find(c => c.id === record.cryptocurrency_id);
                return crypto ? `${crypto.coin_symbol} (${crypto.symbol})` : record.cryptocurrency_id;
            }
        },
        {
            key: "daily_reward_percent",
            text: t('daily_reward_percent'),
            className: "daily_reward_percent",
            align: "left",
            sortable: true,
            cell: (record) => `${record.daily_reward_percent}%`
        },
        {
            key: "staking_type",
            text: t('staking_type'),
            className: "staking_type",
            align: "left",
            sortable: true,
            cell: (record) => record.staking_type?.replace('_', ' ')
        },
        {
            key: "locking_days",
            text: t('locking_days'),
            className: "locking_days",
            align: "left",
            sortable: true,
        },
        {
            key: "total_staking_supply",
            text: t('total_staking_supply'),
            className: "total_staking_supply",
            align: "left",
            sortable: true,
        },
        {
            key: "status",
            text: t('status'),
            className: "status",
            align: "left",
            sortable: true,
        },
        {
            key: "action",
            text: t('actions'),
            className: "Action d-flex",
            align: "left",
            sortable: true,
            cell: (record) => {
                return (
                    <>
                        <Button variant="primary" size="sm" className="me-1" onClick={() => handleView(record)}>
                            {t('view')}
                        </Button>
                        <Button variant="info" size="sm" className="me-1" onClick={() => handleEdit(record)}>
                            {t('edit')}
                        </Button>
                    </>
                );
            },
        },
    ];

    const config = {
        page_size: 10,
        length_menu: [10, 20, 50],
        filename: "Staking Plans List",
        no_data_text: t('no_record_found'),
        button: {
            // print: true,
            // csv: true,
        },
        language: {
            filter: t('search_in_records'),

            pagination: {
                first: t('first'),
                previous: t('previous'),
                next: t('next'),
                last: t('last'),
            },
        },
        show_length_menu: true,
        show_filter: true,
        show_pagination: true,
        show_info: true,
    };

    return (
        <section className="section dashboard">
            <div className="pagetitle d-flex align-items-center justify-content-between mb-4">
                <h1>{t('staking_plans')}</h1>
                <Button variant="primary" onClick={() => setShowAdd(true)}>
                    {t('add_new_staking_plan')}
                </Button>
            </div>

            <div className="card">
                <div className="card-body pt-4">
                    <ReactDatatable
                        key={`datatable-aa`}
                        config={config}
                        records={plans}
                        columns={columns}
                        dynamic={false}

                    />

                </div>
            </div>

            <EditStakingPlan
                show={showEdit}
                onHide={() => setShowEdit(false)}
                plan={editData}
                cryptocurrencies={cryptocurrencies}
            />

            <ViewStakingPlan
                show={showView}
                onHide={() => setShowView(false)}
                viewData={viewData}
                cryptocurrencies={cryptocurrencies}
            />

            <AddStakingPlan
                show={showAdd}
                onHide={() => setShowAdd(false)}
                cryptocurrencies={cryptocurrencies}
            />

        </section>
    );
}

export default StakingPlans;
